module.exports = __webpack_public_path__ + "img/Afghanistan.ca194748.gif";